import DashboardPreferences from './dashboard-preferences.connect'

export default DashboardPreferences
